import Vue, { PluginObject, VueConstructor } from 'vue';
import { ConfigurationPlugin } from '@/plugins/configuration/configuration';
import { IConfigurationService } from '@/app-modules/config';
import { container } from '@/app-modules/_ioc';
import { SERVICE_IDENTIFIERS } from '@/app-modules/_ioc/service-identifiers';

interface IPluginOptions {
  default: string;
}

class Plugin implements PluginObject<IPluginOptions> {
  [key: string]: any;

  public install(vue: VueConstructor, options?: IPluginOptions): void {
    const defaultConfiguration = options && options.default ? options.default : 'EN';

    Object.defineProperty(vue.prototype, '$config', {
      get() { return (this as Vue).$root._config; }
    });

    Vue.mixin({
      beforeCreate() {
        vue.util.defineReactive(this, '_config', new ConfigurationPlugin({tenant: defaultConfiguration}));
      }
    });
  }
}

function initialiseUiConfigurationFromServer(): void {
  const configurationService: IConfigurationService = container.get(SERVICE_IDENTIFIERS.IConfigurationService);
  configurationService.getConfiguration();
  configurationService.getHamsterRaceTicketSetConfiguration();
}

export default {
  init(tenant: string) {
    initialiseUiConfigurationFromServer();

    Vue.use(new Plugin(), {
      default: tenant
    });
  }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/plugins/configuration/plugin.ts